import { createSlice } from '@reduxjs/toolkit';
import { defaultHouseBillingHistorySlice } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.types';
import { fetchHouseBillingHistory } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.actions';
import difference from 'lodash/difference';

const houseBillingHistorySlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchHouseBillingHistory.pending, (slice, { meta }) => {
            slice.loading.push(meta.arg.houseId);
        });
        builder.addCase(fetchHouseBillingHistory.fulfilled, (slice, { meta, payload }) => {
            slice.byId[meta.arg.houseId] = payload;
            slice.loading = difference(slice.loading, [meta.arg.houseId]);
        });
        builder.addCase(fetchHouseBillingHistory.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, [meta.arg.houseId]);
        });
    },
    initialState: defaultHouseBillingHistorySlice,
    name: 'houseBillingHistory',
    reducers: {},
});

export const { reducer: houseBillingHistoryReducer } = houseBillingHistorySlice;
